'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import BackSubscriptionForm from 'Components/Forms/Models/User/BackSubscriptionForm';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
const {
  app
} = window;
export default class NewSubscriptionPage extends Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const back_url = app.state.session.user?.roles?.includes?.('admin') ? URL('PreSubscriptionsDashboard') : URL('AdminSubscriptionsDashboard');
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Nouvel abonnement"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement(Button, {
      component: Link,
      href: back_url,
      className: "u-margin-bottom-15"
    }, '<', "\xA0Retour aux r\xE9servations"), /*#__PURE__*/React.createElement(BackSubscriptionForm, null)));
    return output;
  }
}
